<template>
  <Dropdown v-model="show" class="mr-3" class-prop="lg:w-96" mobile-title="Guests">
    <template #button>
      <button
        ref="button"
        class="whitespace-nowrap rounded bg-gray-light p-3 font-medium hover:text-blue focus:outline-none"
        :class="{ 'text-blue': show || filters.num_guests }"
        @click="show = !show"
      >
        <span v-if="filters.num_guests">
          {{ numGuests }} {{ $f.pluralize('guest', numGuests) }}
        </span>
        <span v-else>Guests</span>
      </button>
    </template>

    <GuestsRoomsSelectors
      v-model:num-guests="numGuests"
      v-model:num-rooms="numRooms"
      :max-guests="maxGuests"
      :min-guests="minGuests"
      :max-rooms="maxRooms"
      :min-rooms="minRooms"
    />

    <template #footer>
      <div class="flex justify-between">
        <button v-if="filters.num_guests" class="letter-sp15 h-10 text-sm font-medium uppercase leading-10" @click="clearFilter">
          Clear All
        </button>
        <div class="grow text-right">
          <button
            class="letter-sp15 h-10 rounded-md bg-blue px-4 text-sm uppercase leading-10 text-white hover:bg-blue-dark md:px-8"
            @click="applyFilter"
          >
            Update
          </button>
        </div>
      </div>
    </template>
  </Dropdown>
</template>

<script>
import Dropdown from '~/components/shared/Dropdown'
import GuestsRoomsSelectors from '~/components/shared/GuestsRoomsSelectors'

export default {
  components: { Dropdown, GuestsRoomsSelectors },

  props: {
    filters: { type: Object, required: true },
  },

  emits: ['update', 'apply'],

  data: () => ({
    show: false,
    numGuests: 2,
    numRooms: 1,
    minGuests: 1,
    maxGuests: 20,
    minRooms: 1,
    maxRooms: 10,
  }),

  computed: {
    // ...mapState({
    //   loading: s => s.venues.totals.loading,
    //   total: s => s.venues.totals.total,
    // }),
  },

  watch: {
    datesRange: {
      deep: true,
      handler () {
        this.applyFilter()
      },
    },
  },

  methods: {
    getFilterData () {
      return {
        num_guests: this.numGuests,
        num_rooms: this.numRooms,
      }
    },

    applyFilter (hide = true) {
      this.updateValues(this.getFilterData())
      if (hide) {
        this.show = false
      }
    },

    updateTotals () {
      this.$emit('update', Object.assign({}, this.filters, this.getFilterData()))
    },

    clearFilter () {
      this.updateValues({ num_guests: null, num_rooms: null })
      this.numGuests = 2
      this.numRooms = 1
      this.show = false
    },

    updateValues (values) {
      this.$emit('apply', Object.assign({}, values))
    },
  },
}
</script>
